/**
 * The member account screens that render as the full-screen Monet split
 * (AuthShell variant="art"). They carry their own Terms · Privacy line, so
 * the site footer is left off them — in both App.tsx and routes-ssr.tsx.
 */
export function isAuthScreenPath(location: string): boolean {
  return (
    location === "/login" ||
    location === "/signup" ||
    location === "/claim" ||
    location.startsWith("/auth/")
  );
}

/**
 * The AI Context Toolkit (/kit, /kit/*) runs full screen on its own painting,
 * so it leaves the site footer off too (Esther, 2026-10-30). So does its
 * landing page, /ai-context-toolkit, which is a single-ask page.
 */
export function isToolkitPath(location: string): boolean {
  return location === "/kit" || location.startsWith("/kit/") || location === "/ai-context-toolkit";
}
